<!-- 由 woniu6162 创建于 2020-12-10 星期四 -->
<template>
  <div class="ReductionProgress">
    <div class="pp_header">
      <div class="pp_h_title">{{ title }}</div>
      <div class="pp_h_per">{{ `${finish}/${list.length} ` }}</div>
    </div>
    <div class="pp_h_main">
      <div class="pp_hm_wrap">
        <template v-for="(item, index) in list">
          <div
            :key="index"
            :class="['pp_hmw_item', fClass(step, index + 1, item)]"
          >
            <div class="pp_hmwi_up">
              <div v-show="item.body_measurements">
                {{ item.body_measurements }}
              </div>
            </div>
            <div class="pp_hmwi_box" />
            <div class="pp_hmwi_down">
              <div class="pp_hmwid_title">{{ `第${index + 1}节` }}</div>
              <div>
                <div
                  class="pp_hmwid_time"
                  v-html="item.date.replace(/\-/g, '.')"
                />
                <div
                  class="pp_hmwid_range"
                  v-if="item.start_time"
                  v-html="`${item.start_time}-${item.end_time}`"
                />
              </div>
            </div>
          </div>
        </template>
        <div class="pp_hmw_line" />
        <div
          class="pp_hmwl_is"
          :style="{ width: lineWidth(step, list.length) }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReductionProgress',

  mixins: [],

  components: {},

  props: {
    title: {},
    finish: {},
    step: {},
    list: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    console.log('step', this.step)
  },

  destroyed() {},

  methods: {
    // 进度条-长度
    lineWidth(cur, len) {
      let str = `${(((cur - 1) / len) * 100).toFixed(0)}%`
      return str
    },
    // 进度条-样式
    fClass(cur, index, item) {
      let str = ''
      if (index <= cur) {
        str = 'pp_hmwi_appoint'
      }
      if ([3, 4].includes(item.status)) {
        str = 'pp_hmwi_done'
      }
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
.ReductionProgress {
  margin-top: 4vw;
  .pp_header {
    display: flex;
    align-items: center;
    .pp_h_title {
      font-size: 3.5vw;
      color: #000;
    }
    .pp_h_per {
      margin-left: 2.7vw;
      font-size: 2.9vw;
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .pp_h_main {
    margin-top: 1.2vw;
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .pp_hm_wrap {
      width: fit-content;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .pp_hmw_item {
        width: 20vw;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        & > div {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
        }
        .pp_hmwi_up {
          height: 10vw;
          & > div {
            font-size: 2.7vw;
            color: #fff;
            padding: 0.6vw 1.5vw;
            background-color: #2882e9;
            border-radius: 1.1vw;
          }
        }
        .pp_hmwi_box {
          width: 4.3vw;
          height: 4.3vw;
          border-radius: 50%;
          background-color: #fff;
          border: solid 0.8vw #e7e7e7;
          position: relative;
          z-index: 3;
        }
        .pp_hmwi_down {
          height: 16vw;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          color: #000;
          padding: 1vw 0;
          text-align: center;
          .pp_hmwid_title {
            font-size: 3.2vw;
          }
          .pp_hmwid_time {
            font-size: 2.7vw;
          }
          .pp_hmwid_range {
            margin-top: 0.2vw;
            font-size: 3.2vw;
          }
        }
      }
      // 进度条-预约样式
      .pp_hmwi_appoint {
        .pp_hmwi_up > div {
          background-color: #2882e9;
        }
        .pp_hmwi_box {
          border: solid 0.8vw #dc0050;
        }
      }
      // 进度条-已上课样式
      .pp_hmwi_done {
        .pp_hmwi_up > div {
          background-color: #ccc;
        }
        .pp_hmwi_box {
          background-color: #dc0050;
          border: solid 0.8vw #dc0050;
        }
        .pp_hmwi_down {
          color: rgba(0, 0, 0, 0.3);
        }
      }
      .pp_hmw_line {
        width: calc(100% - 20vw);
        height: 1vw;
        background: #e7e7e7;
        position: absolute;
        top: 11.6vw;
        left: 9.5vw;
        z-index: 1;
      }
      .pp_hmwl_is {
        height: 1vw;
        background: #dc0050;
        position: absolute;
        top: 11.6vw;
        left: 9.5vw;
        z-index: 2;
      }
    }
  }
}
</style>
